module.exports = __webpack_public_path__ + "media/images/flags/GB-NIR-bc4147dadf2eec6426730d7e82a1517a.svg";